import { mapActions, mapGetters } from 'vuex';
import fbIcon from '@/assets/icons/footer/facebook.svg';
import instaIcon from '@/assets/icons/footer/instagram.svg';
import twitterIcon from '@/assets/icons/footer/x.svg';
import youtubeIcon from '@/assets/icons/footer/youtube.svg';
import { MODALS } from '@/components/app/app-modals/modals-constants';

export default {
  data() {
    return {
      debugClickCount: 0,
      debugClickThreshold: 7,
      debugClickTimer: null,
      footerExpandRafId: null,
      screenWidth: 1024,
      visibleSections: ['legal'],
      expanded: true,
      items: [
        { title: 'Instagram', href: process.env.PI_INSTAGRAM_LINK, icon: instaIcon },
        { title: 'Youtube', href: process.env.PI_YOUTUBE_LINK, icon: youtubeIcon },
        { title: 'Twitter', href: process.env.PI_TWITTER_LINK, icon: twitterIcon },
        { title: 'Facebook', href: process.env.PI_FACEBOOK_LINK, icon: fbIcon },
      ],
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop', 'isLayoutMobile', 'leaderboardsEnabled']),
    classModifiers() {
      return {
        footer: true,
        'footer--expanded': this.expanded,
      };
    },
    isLayoutPhone() {
      return this.screenWidth < 640;
    },
    footerBottomChevronModifiers() {
      return {
        'footer__bottom-chevron': true,
        'footer__bottom-chevron--opened': this.expanded,
      };
    },
  },
  methods: {
    ...mapActions('popup', ['setCurrentPopup']),
    ...mapActions('search', ['toggleSearchBar']),
    ...mapActions('onboarding', ['showOnboardingStep']),
    handleSecretTap() {
      this.debugClickCount += 1;
      clearTimeout(this.debugClickTimer);
      this.debugClickTimer = setTimeout(() => {
        this.debugClickCount = 0;
      }, 2000);
      if (this.debugClickCount >= this.debugClickThreshold) {
        this.debugClickCount = 0;
        this.$router.push({ name: 'user-status' });
      }
    },
    onDetailsToggle() {
      this.expanded = !this.expanded;
    },
    onFrame() {
      window.scrollTo(0, document.body.scrollHeight);
      this.footerExpandRafId = window.requestAnimationFrame(this.onFrame);
    },
    onFooterExpandStopFrame() {
      if (this.footerExpandRafId !== null) {
        window.cancelAnimationFrame(this.footerExpandRafId);
        this.footerExpandRafId = null;
      }
    },
    onFooterExpandEnter() {
      this.footerExpandRafId = window.requestAnimationFrame(this.onFrame);
    },
    resizeHandler() {
      this.screenWidth = window.innerWidth ||
        document.documentElement.clientWidth ||
        document.getElementsByTagName('body')[0].clientWidth;
    },
    sectionClassModifiers(name) {
      return {
        'footer__section-title': true,
        'footer__section-title--opened': this.visibleSections.includes(name),
      };
    },
    toggleSection(name) {
      if (!this.isLayoutPhone) return;
      if (this.visibleSections.includes(name)) {
        this.visibleSections = [...this.visibleSections.filter(i => i !== name)];
      } else {
        this.visibleSections = [
          ...this.visibleSections,
          name,
        ];
      }
    },
    isSectionVisible(name) {
      return !this.isLayoutPhone || (this.isLayoutPhone && this.visibleSections.includes(name));
    },
    onLogin() {
      this.setCurrentPopup(MODALS.LOGIN);
    },
    onSignUp() {
      this.setCurrentPopup(MODALS.REGISTER);
    },
  },
  created() {
    window.addEventListener('resize', this.resizeHandler);
    this.resizeHandler();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeHandler);
    this.onFooterExpandStopFrame();
  },
};



// WEBPACK FOOTER //
// ./src/components/app/app-footer/app-footer.js